import { FC, ReactNode } from "react";
import { Box } from "@mui/material";
import { makeSxStyles } from "ui";

interface FormLayoutProps {
  children: ReactNode;
  maxWidth?: string;
  marginTop?: string;
}

const useStyles = makeSxStyles(() => ({
  container: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    rowGap: "16px",
    alignItems: "center",
  },
}));

const FormLayout: FC<FormLayoutProps> = ({
  children,
  maxWidth = "50%",
  marginTop = "40px",
}) => {
  const styles = useStyles();

  return (
    <Box
      sx={{
        ...styles.container,
        maxWidth,
        mt: marginTop,
      }}
    >
      {children}
    </Box>
  );
};

export default FormLayout;
